import { useEffect } from "react";
import { LanderConfigAction, useLanderConfig } from "../commons/ConfigContext";
import { LanderCookie } from "../commons/Constants";
import { getCookie } from "../commons/HelperFunctions";
import { ExperimentIds } from "../commons/constants/experiment";
import { FeedType } from "../types/LanderConfig";
import { isControlCohort } from "./helper";

export const AIRO_CONTROL_TYPE_TAG = "PW_AIRO_CONTROL";
export const AIRO_TREATMENT_TYPE_TAG = "PW_AIRO_TREATMENT";

export function useAiroBannerExperiment() {
  const { landerConfig, landerConfigDispatch } = useLanderConfig();
  const { experiment: { key, cohort } = {} } = landerConfig;

  const inExperiment = key === ExperimentIds.airoBuilderBanner;
  const inTreatmentCohort = inExperiment && cohort && !isControlCohort(cohort);
  const isYahooFeed = landerConfig.lander?.feedID === FeedType.YAHOO;
  const isUS = getCookie(LanderCookie.COUNTRY) === "US";
  const hasBanner =
    !!landerConfig.lander?.banner?.show && !!landerConfig.lander?.banner?.link;
  const isEligible = inExperiment && isYahooFeed && isUS && hasBanner;
  const showAiroAd = isEligible && inTreatmentCohort;

  useEffect(() => {
    if (!isEligible) return;

    landerConfigDispatch({
      type: LanderConfigAction.UPDATE_BANNER_AND_CHANNEL_BY_TREATMENT,
      payload: { inTreatmentCohort },
    });

    landerConfigDispatch({
      type: LanderConfigAction.UPDATE_YAHOO_TYPE_TAG,
      payload: {
        typeTag: inTreatmentCohort
          ? AIRO_TREATMENT_TYPE_TAG
          : AIRO_CONTROL_TYPE_TAG,
      },
    });
  }, [isEligible, inTreatmentCohort, landerConfigDispatch]);

  return { showAiroAd };
}
